import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import appTheme from '@/v2/theme'
import utilityUsageTheme from '@/authenticated/components/UtilityUsage/theme'
import DailyTOURateOverview from './DailyTOURateOverview'

// Base the component's MUI theme on the app's v2 theme so its typography (Inter)
// is correct wherever it renders — not the ambient/default MUI font — while
// layering on the `utilityUsageTheme` palette/border (incl. the `spectrum`
// colours the rate viz needs). Done here, in the shared wrapper, so every
// consumer (usage page, home overview, utility selection) gets it.
const dailyTouTheme = createTheme({
  ...appTheme,
  palette: {
    ...appTheme.palette,
    ...utilityUsageTheme.palette,
  },
  border: {
    ...(appTheme.border || {}),
    ...utilityUsageTheme.border,
  },
})

const TimeOfUseOverview = ({
  seasonalRateSummary,
  showCurrentRateHeader = true,
}) => {
  return (
    <ThemeProvider theme={dailyTouTheme}>
      <DailyTOURateOverview
        fullSeasonalRateSummary={seasonalRateSummary}
        showCurrentRateHeader={showCurrentRateHeader}
      />
    </ThemeProvider>
  )
}

export default TimeOfUseOverview
